module.exports = __webpack_public_path__ + "img/file-nom.53a2781d.svg";